export const benefitTypes = {
    1: 'Beneficio Multiplicación',
    2: 'Beneficio Reembolso'
};
